<template>
  <div class="explore-items-wrap" v-if="!isLoading && !welcomeOffers.length">
    <img :src="this.modulePropsData?.exploreMenuImage" class="pb16" />
    <div class="menu-title">{{ this.modulePropsData?.exploreMenuTitle }}</div>
    <button @click="handleClickCTA" class="btn large secondary w100">
      {{ this.modulePropsData?.exploreMenuCta }}
    </button>
  </div>
</template>
<script>
import { EVENT_CLICK_CART_EXPLOREMENU } from "../helpers/analyticsEvents";
import Utility from "../helpers/utility.js";
export default {
  name: "ExploreMenuItems",
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData: {},
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    handleClickCTA() {
      EVENT_CLICK_CART_EXPLOREMENU();
      Utility.sendToMenuScreen(this.modulePropsData?.noOfferMenuLink);
    },
  },
  computed: {
    isLoading() {
      return this.$store.state.Loader.isLoading;
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
  },
};
</script>
